import * as tslib_1 from "tslib";
import styled, { css } from 'styled-components';
export var getFlexDirection = function (props) {
    return props.column ? 'column' : 'row';
};
export var gridLayoutCss = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  > * {\n    width: ", "%;\n  }\n"], ["\n  > * {\n    width: ", "%;\n  }\n"])), function (props) { return 100 / props.columns; });
/**
 * 用于包装一组`Checkbox`和`Switch`的组件。可以控制组件横向或者纵向显示。使用`RadioGroup`来显示一组`Radio`。
 *
 * @ReactComponent
 */
var FormGroup = styled.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  flex-wrap: wrap;\n  ", ";\n"])), getFlexDirection, function (props) { return props.gridLayout && props.columns > 0 && gridLayoutCss; });
export default FormGroup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormGroup.js.map